import queryString from "query-string";
import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { useHistory, useLocation } from "react-router-dom";
import excelIcon from "../../../icons/excel.png";
import fileIcon from "../../../icons/file.png";
import { Card2 } from "../../../shared/Card2";
import PageHeader from "../../Docuclipper/PageHeader/PageHeader";

const titleHeight = "40px";

export function ViewOtherDocuments() {
  const history = useHistory();
  const location = useLocation();
  const existingParams = queryString.parse(location.search);
  const { category } = existingParams;

  return (
    <div style={{ maxWidth: 1200 }}>
      <PageHeader title="View Other Documents" description="">
        <Row className="" style={{ maxWidth: 800 }}>
          <Col xs="12" md="6">
            <Card2
              titleStyle={{ minHeight: titleHeight }}
              btnClassName="tool--generic"
              loading={false}
              heading={
                <>
                  <span>Automatic conversion</span>
                </>
              }
              // subheading="Convert any PDF document into a spreadsheet"
              subheading={
                <>
                  <span>View documents extracted in automatic mode</span>
                </>
              }
              img={{
                alt: "",
                src: excelIcon,
                width: "75px",
                height: "",
              }}
              cta="View Docs"
              onClick={() => {
                const path = "/otherDocs";
                const search = queryString.stringify(existingParams);
                history.push(`${path}${search ? `?${search}` : ""}`);
              }}
            />
          </Col>
          <Col xs="12" md="6">
            <Card2
              titleStyle={{ minHeight: titleHeight }}
              btnClassName="tool--custom-templte"
              loading={false}
              heading="Custom Template (advanced)"
              // subheading="Create a custom template that specifies what data is extracted and the format."
              subheading={
                <>
                  <span>View documents extracted with a template</span>
                </>
              }
              img={{
                alt: "",
                src: fileIcon,
                width: "75px",
                height: "",
              }}
              cta="View Docs"
              onClick={() => {
                const path = "/templateDocs";
                const search = queryString.stringify(existingParams);
                history.push(`${path}${search ? `?${search}` : ""}`);
              }}
            />
          </Col>
        </Row>
      </PageHeader>
    </div>
  );
}

export default ViewOtherDocuments;
